import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import ComPDFKitViewer from "@compdfkit_pdf_sdk/webviewer";
import { Signing_HOST_API, getSigningFileUrl } from "../config";
import { Container } from "@cloudscape-design/components";
import TopNavigation from "@cloudscape-design/components/top-navigation";
import axiosInstance from "../context/axios";
import { captureException } from "@sentry/react";
import SigningLoader from "./signing-loader";
import { isArray } from "lodash";

export function CompdfSigningDocument() {
  const [searchParams] = useSearchParams();
  const viewer = useRef(null);
  const [instance, setInstance] = useState(undefined);
  const [xfdfString, setXfdfString] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [documentLoaded, setDocumentLoaded] = useState(false);
  const [annoteImported, setAnnoteImported] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(Signing_HOST_API + "?" + searchParams.toString(), {
        headers: { "X-Org-ID": searchParams.get("org_id") ?? "-1" },
      })
      .then(async (response) => {
        if (response?.status === 200)
          setXfdfString(response.data.annotationsJson);
        else if (window.location.host === "localhost:3000")
          setXfdfString(response.data.annotationsJson);
        else navigate("error");
        setIsLoading(false);
      })
      .catch((error) => {
        captureException(error);
        console.error({ error });
        if (window.location.host === "localhost:3000")
          setXfdfString(
            '[{"type":"textfield","rect":{"left":31.4251968503937,"top":261.60629921259846,"right":211.42519685039372,"bottom":286.6062992125984},"fieldName":"Standard_Text Field#standard_fields.text_field#true#string#0#","isHidden":0,"contents":"","backgroundColor":"#93B9FD","fillColor":"#93B9FD","color":"#000000","fontName":"Helvetica","fontSize":14,"textAlignment":"left","isMultiLine":false,"pageIndex":0,"checkStyle":1,"borderWidth":0,"author":"Guest","date":"2025-06-24T18:40:19.539Z","name":"1f78c107-caca-4cfe-8212-c3ae2265a2e0","pagePtr":2516448,"annotPtr":30375024,"fontStyle":"normal","fontWeight":"normal","borderStyle":"solid","borderColor":"#000000","required":0,"prePageIndex":0},{"type":"checkbox","rect":{"left":415.59842519685037,"top":232.55905511811025,"right":435.59842519685037,"bottom":252.55905511811025},"fieldName":"Standard_Check Box#standard_fields.check_box#true#bool#0#","isHidden":0,"contents":"Off","backgroundColor":"#93B9FD","fillColor":"#93B9FD","color":"#000000","fontName":"Helvetica","fontSize":14,"textAlignment":"left","isMultiLine":false,"pageIndex":0,"checkStyle":1,"borderWidth":0,"author":"Guest","date":"2025-06-24T18:40:22.543Z","name":"6e41cdf0-371d-453f-8e45-5d63ff34a732","pagePtr":2516448,"annotPtr":30422768,"borderstyle":"solid","borderColor":"#000000","prePageIndex":0},{"type":"textfield","rect":{"left":53.91338582677165,"top":202.5748031496063,"right":233.91338582677167,"bottom":227.57480314960628},"fieldName":"Personal Info_First Name#firstName#false#string##","isHidden":0,"contents":"Melanie","backgroundColor":"#93B9FD","fillColor":"#93B9FD","color":"#000000","fontName":"Helvetica","fontSize":14,"textAlignment":"left","isMultiLine":false,"pageIndex":0,"checkStyle":1,"borderWidth":0,"author":"Guest","date":"2025-06-24T18:40:26.053Z","name":"ce8d6f3c-c167-4ad5-be93-83575ed2a952","pagePtr":2516448,"annotPtr":30377008,"fontStyle":"normal","fontWeight":"normal","borderStyle":"solid","borderColor":"#000000","required":0,"prePageIndex":0},{"type":"signatureFields","rect":{"left":409.9763779527559,"top":296.2755905511811,"right":589.9763779527559,"bottom":321.2755905511811},"fieldName":"Standard_Signature#standard_fields.signature#true#signature#0#","isHidden":0,"contents":"","backgroundColor":"#93B9FD","fillColor":"#93B9FD","color":"#000000","fontName":"Helvetica","fontSize":14,"textAlignment":"left","isMultiLine":false,"pageIndex":0,"checkStyle":1,"borderWidth":0,"author":"Guest","date":"2025-06-24T20:03:58.282Z","name":"9263e8a2-6569-4d3c-b41e-9eb8f8ccf020","pagePtr":2516448,"annotPtr":30428160,"borderStyle":"solid","borderColor":"#000000","imageBase64":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYEAAAA2CAYAAAAh4SVdAAAAAXNSR0IArs4c6QAAAepJREFUeF7t1cEJACAQA0Ht/2s11iYo2MbOdZDJQeba5w5HgAABAkmBaQSSvQtNgACBL2AEPAIBAgTCAkYgXL7oBAgQMAJ+gAABAmEBIxAuX3QCBAgYAT9AgACBsIARCJcvOgECBIyAHyBAgEBYwAiEyxedAAECRsAPECBAICxgBMLli06AAAEj4AcIECAQFjAC4fJFJ0CAgBHwAwQIEAgLGIFw+aITIEDACPgBAgQIhAWMQLh80QkQIGAE/AABAgTCAkYgXL7oBAgQMAJ+gAABAmEBIxAuX3QCBAgYAT9AgACBsIARCJcvOgECBIyAHyBAgEBYwAiEyxedAAECRsAPECBAICxgBMLli06AAAEj4AcIECAQFjAC4fJFJ0CAgBHwAwQIEAgLGIFw+aITIEDACPgBAgQIhAWMQLh80QkQIGAE/AABAgTCAkYgXL7oBAgQMAJ+gAABAmEBIxAuX3QCBAgYAT9AgACBsIARCJcvOgECBIyAHyBAgEBYwAiEyxedAAECRsAPECBAICxgBMLli06AAAEj4AcIECAQFjAC4fJFJ0CAgBHwAwQIEAgLGIFw+aITIEDACPgBAgQIhAWMQLh80QkQIGAE/AABAgTCAkYgXL7oBAgQMAJ+gAABAmEBIxAuX3QCBAg8DRmxne47SJoAAAAASUVORK5CYII="}]'
          );
        else navigate("error");
        setIsLoading(false);
      });
  }, [searchParams]);

  useEffect(() => {
    if (viewer.current != null && !!xfdfString)
      ComPDFKitViewer.init(
        {
          path: "/",
          license: "Njg0YmEwYjM5OTZkNw==",
        },
        viewer.current
      )
        .then((instance) => {
          setInstance(instance);
          const { UI } = instance;
          UI.textPopup.update([]);
          UI.setEnableSignatureTemplates(false);
          UI.setSignatureDialogTabs(["trackpad", "image"]);
          UI.disableElements(["header"]);
          instance.UI.closeElement("leftPanel");
          const docViewer = instance.docViewer;
          docViewer.setToolMode("form");
          docViewer.addEvent("documentloaded", async () => {
            instance.UI.closeElement("rightPanel");
            const pageWidth = instance.docViewer.getPageWidth(1);
            const viewerContainer = document.getElementById("compdf");
            const viewerWidth = viewerContainer.clientWidth;
            docViewer.webViewerScaleChanged(viewerWidth / pageWidth);
            setDocumentLoaded(true);
          });
        })
        .catch((error) => {
          captureException(error);
          console.log({ error });
        });
  }, [xfdfString]);

  useEffect(() => {
    const fileKey = searchParams.get("file");
    if (!instance) return;
    if ("localhost" === window.location.hostname) {
      instance.UI.loadDocument("./example/developer_guide_web.pdf");
    } else if (!!fileKey) {
      console.log(
        encodeURI(getSigningFileUrl(fileKey)) + "?" + searchParams.toString()
      );
      instance.UI.loadDocument(
        encodeURI(getSigningFileUrl(fileKey)) + "?" + searchParams.toString(),
        {
          withCredentials: true,
        }
      );
    }
  }, [instance]);

  useEffect(() => {
    if (!documentLoaded || annoteImported || !instance || !xfdfString) return;
    const docViewer = instance.docViewer;
    const annotes = JSON.parse(xfdfString);
    if (!!annotes && isArray(annotes)) {
      annotes?.forEach((annote) => {
        delete annote?.date;
        docViewer.addAnnotations({
          ...annote,
        });
      });
    }
    setAnnoteImported(true);
  }, [documentLoaded, annoteImported, xfdfString, instance]);

  if (!!isLoading) return <SigningLoader />;
  else
    return (
      <Container
        header={
          <TopNavigation
            identity={{
              href: "#",
              title: "",
              logo: {
                src: "/assets/White logo - no background.png",
                alt: "Incredable logo",
              },
            }}
            utilities={[
              {
                type: "button",
                variant: "primary-button",
                text: "Submit",
                onClick: async () => {
                  if (!instance) return;
                  const { docViewer } = instance;
                  const annotationManager = docViewer.getAnnotationManager();
                  const annotationsList =
                    annotationManager.getAnnotationsList();
                  console.log({ annotationsList });
                  for (const annote of annotationsList) {
                    annote.backGroundColor = "#FFFFFF";
                    annote.fillColor = "#FFFFFF";
                  }
                  console.log({ annotationsList });

                  const annotes = await docViewer.exportFomrXfdf();
                  console.log({ annotes });
                  await axiosInstance({
                    method: "post",
                    url: Signing_HOST_API + "?" + searchParams.toString(),
                    headers: {
                      "Content-Type": "text/plain",
                      "X-Org-ID": searchParams.get("org_id") ?? "-1",
                    },
                    data: annotes,
                  });
                  navigate("/signing/success");
                },
              },
              {
                type: "button",
                variant: "secondary-button",
                text: "Download",
                onClick: async () => {
                  if (!instance) return;
                  await downloadFile(instance);
                },
              },
              {
                type: "button",
                variant: "secondary-button",
                text: "Print",
                onClick: async () => {
                  if (!instance) return;
                  console.log("Printing document...");
                  await instance?.docViewer.webViewerNamedAction({
                    action: "Print",
                  });
                  console.log("Document sent to print.");
                },
              },
            ]}
          />
        }
      >
        {(!!searchParams.has("file") ||
          window.location.host === "localhost:3000") && (
          <div
            ref={viewer}
            id="compdf"
            style={{
              height: `calc(100vh - 100px)`,
            }}
          />
        )}
        {!searchParams.has("file") && <h1>No file found</h1>}
      </Container>
    );
}

const downloadFile = async (instance) => {
  try {
    const arrayBuffer = await instance.docViewer.download();

    const blob = new Blob([arrayBuffer], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "document.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download failed", error);
  }
};
